import type {
  GlobalContextAction,
  GlobalContextReducerState
} from './reducers/types';

export interface GlobalContextProviderProps {
  children: React.ReactNode;
  initialValue?: GlobalContextReducerState;
}

export enum ContextAction {
  setLayout = 'SET_LAYOUT',
  setLang = 'SET_LANG',
  setUser = 'SET_USER',
  setRoute = 'SET_ROUTE',
  setActiveFeatureConfig = 'SET_ACTIVE_FEATURE_CONFIG',
  setPortal = 'SET_PORTAL',
  setNavItems = 'SET_NAV_ITEMS',
  setCountryData = 'SET_COUNTRY_DATA',
  setCoBrandDetails = 'SET_CO_BRAND_DETAILS'
}

export interface GlobalContextState {
  state: GlobalContextReducerState;
  dispatch: React.Dispatch<GlobalContextAction>;
}
